import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '../../store'

import type { CreateWorkspaceSliceState } from './CreateWorkspace.slice'

export const selectWorkspace = (state: RootState) => state.createWorkspace

export const selectCreateWorkspaceFirstStep = createSelector(
  selectWorkspace,
  (createWorkspaceState: CreateWorkspaceSliceState) =>
    createWorkspaceState.CreateWorkspaceFirstStep,
)

export const selectCreateWorkspaceSecondStep = createSelector(
  selectWorkspace,
  (createWorkspaceState: CreateWorkspaceSliceState) =>
    createWorkspaceState.CreateWorkspaceSecondStep,
)

export const selectCreateWorkspaceThirdStep = createSelector(
  selectWorkspace,
  (createWorkspaceState: CreateWorkspaceSliceState) =>
    createWorkspaceState.CreateWorkspaceThirdStep,
)
